import { render, staticRenderFns } from "./TableThanhLy.vue?vue&type=template&id=3add5523&"
import script from "./TableThanhLy.vue?vue&type=script&lang=js&"
export * from "./TableThanhLy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports